import { TwoColumnWithBookingSummary } from 'components/Layout';
import { useScrollTopOnMount } from 'lib/hooks';
import RequestReviewInfo from './RequestReviewInfo';
import RequestAlert from './RequestAlert';
import RequestDetails from '../RequestDetails';
import ButtonGroup from 'components/ButtonGroup';
import { useChangeDatesRequestFlowContext } from '../contextProvider/ChangeDatesRequestFlowContextProvider';

const ReviewRequest = () => {
  const { values, backToForm, createDateAmendmentRequestMutation, loading } = useChangeDatesRequestFlowContext();
  const { checkIn, checkOut, phoneNumber, email } = values;

  useScrollTopOnMount();

  return (
    <TwoColumnWithBookingSummary heading="Review your date change request">
      <RequestReviewInfo />
      <RequestDetails mt={8} checkIn={checkIn} checkOut={checkOut} phoneNumber={phoneNumber} email={email} />
      <RequestAlert mt={7} mb={8} />
      <ButtonGroup
        mt={5}
        desktopBackLabel="Back"
        mobileBackLabel="Back"
        withBackIcon
        onClickBack={backToForm}
        continueLabel="Submit Request"
        onClickContinue={createDateAmendmentRequestMutation}
        continueButtonProps={{ loading, disabled: loading }}
      />
    </TwoColumnWithBookingSummary>
  );
};

export default ReviewRequest;
